import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { BaseResponse } from '../models'
import { readToken } from '../token/token'

const _BASE_URL = process.env.REACT_APP_AUTH_API_BASE_URL!

export interface LoginToAcademyResponse {
  loginUrl: string
}

export const academyAuthApi = createApi({
  reducerPath: 'academyAuthApi',
  baseQuery: fetchBaseQuery({
    baseUrl: _BASE_URL,
    prepareHeaders: (headers) => {
      const token = readToken()
      if (token) {
        headers.set('Authorization', `Bearer ${token.accessToken}`)
      }
      return headers
    },
  }),
  tagTypes: ['academy'],
  endpoints: (builder) => ({
    loginToAcademy: builder.mutation<BaseResponse<LoginToAcademyResponse>, null>({
      query: () => ({
        url: `/v2/console/login-to-academy`,
        method: 'POST',
      }),
      invalidatesTags: [],
    }),
  }),
})

export const { useLoginToAcademyMutation } = academyAuthApi
